// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3KOjI","modalForm":"UpgradeEpcsModal_modalForm__2OqAx","modalFooter":"UpgradeEpcsModal_modalFooter__1vpOn"};